<app-layout-modulo-gerencial
  [logo]="sessao.logoEmpresa"
  [iniciais]="sessao.iniciaisEmpresa"
  [nome]="sessao.nomeEmpresa"
  [agora]="agora"
  [aba]="aba"
  [itens]="itensMenu"
  [mensagem]="mensagem"
  (selecionar)="sessao.abrir($event)"
  (sair)="sessao.sair()">
  <app-tela-solicitacoes
    *ngIf="aba === 'ferias'"
    tipo="ferias"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    (empregadorSelecionadoChange)="empregadorSelecionado = $event"
    (mensagem)="mensagem = $event">
  </app-tela-solicitacoes>
  <app-tela-listagem-ferias
    *ngIf="aba === 'ferias-lista'"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    (empregadorSelecionadoChange)="empregadorSelecionado = $event"
    (mensagem)="mensagem = $event">
  </app-tela-listagem-ferias>
  <app-tela-cadastro-secretarias
    *ngIf="aba === 'secretarias'"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    (empregadorSelecionadoChange)="empregadorSelecionado = $event"
    (mensagem)="mensagem = $event">
  </app-tela-cadastro-secretarias>
</app-layout-modulo-gerencial>
